import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import FindStructureData from "helper/FindStructureType";
import { textFormat } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
const CollateralEvaluationMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [disabledButton, setDisabledButton] = useState(true);
  const [disabledButton1, setDisabledButton1] = useState(true);
  const [sameCombination, setSameCombination] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [selectedRoleCode, setSelectedRoleCode] = useState("");
  const [selectedRoleCodeState, setSelectedRoleCodeState] = useState(false);
  const [structureTypeData, setStructureTypeData] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [branchNameState, setBranchNameState] = useState("");
  const [minAmount, setMinAmount] = useState("0");
  const [maxAmount, setMaxAmount] = useState("");
  const [level, setLevel] = useState("");
  const [previouseEvaluation, setPreviouseEvaluation] = useState([]);
  const [bottomTextError, setBottomTextError] = useState("");
  const [designation, setDesignation] = useState("");
  const [designationState, setDesignationState] = useState(false);
  const [designationData, setDesignationData]= useState([])
  const [mandatory, setMandatory] = useState(true);
  const [btPreFlag, setBtPreFlag] = useState(false);
  const [skipFlag, setSkipFlag] = useState(false);
  const [roleBasedApproval, setRoleBasedApproval] = useState(false);
  const [designationBasedApproval, setDesignationBasedApproval] = useState(true);
  const viewPage = window.location.href.includes('createView');
  const outletData = useOutletContext();
  const applicantionSubTypeEnabledColateral = parseAndSetFlag(outletData?.applicantionSubTypeEnabledColateral);
  const enabledSkipLevelCollateralValuation = parseAndSetFlag(outletData?.enabledSkipLevelCollateralValuation);
  useEffect(() => {
    (async () => {
      if (params.id) {
        setCallInProgress(true);
        // Get Data from API
        const result = await apiHandler({
          url: endpoint.COLLATERAL_EVALUATION_FINDBYID + "?id=" + params.id,
          authToken: authToken,
        });
        setCallInProgress(false);
        setSelectedRoleCode(result?.data?.[0]?.role || "");
        setBranchName(result?.data?.[0]?.branchCode || "");
        setMaxAmount(result?.data?.[0]?.maxAmt || "");
        setMinAmount(result?.data?.[0]?.minAmt?.toString() || "");
        setLevel(result?.data?.[0]?.level || "");
        setDesignation(result?.data?.[0]?.designation || "");
        setMandatory(result?.data?.[0]?.mandatory || "");
        setRoleBasedApproval(result?.data?.[0]?.roleBasedApproval || "");
        setDesignationBasedApproval(result?.data?.[0]?.designationBasedApproval || "");
        setSkipFlag(result?.data?.[0]?.skip);
        if(result?.data?.[0]?.applicationSubType){
          setBtPreFlag(true);
        }else {
          setBtPreFlag(false);
        };
      }
    })();
  }, []);
  useEffect(() => {
  let isValid = false;

  if (designationBasedApproval && !roleBasedApproval) {
    isValid = maxAmount && branchName && designation && sameCombination?.length === 0;
  } else if (roleBasedApproval && !designationBasedApproval) {
    isValid = maxAmount && branchName && selectedRoleCode && sameCombination?.length === 0;
  } else {
    isValid =
      maxAmount &&
      branchName &&
      selectedRoleCode &&
      designation &&
      sameCombination?.length === 0;
  }

  if (isValid) {
    setDisabledButton(false);
    setDisabledButton1(false);
  } else {
    setDisabledButton(true);
    setDisabledButton1(true);
  }
}, [
  maxAmount,
  branchName,
  selectedRoleCode,
  designation,
  sameCombination,
  designationBasedApproval,
  roleBasedApproval,
]);

  useEffect(() => {
    getRoleList();
    // GetHierarchyData();
    FindStructureData(apiHandler, endpoint, authToken, setStructureTypeData);
    getDesignationFindAll();
  }, []);

  useEffect(() => {
    if (branchName) {
      GetPreviouseValuationFind();
    }
  }, [branchName,btPreFlag]);
  const getDesignationFindAll = async ()=>{
    setCallInProgress(true)
      const result = await apiHandler({
        url: endpoint.DESIGNATION_FINDALL,
        authToken: authToken,
      });
      setCallInProgress(false)
      if(result?.data){
        setDesignationData(result?.data)
      }
  }
 const GetPreviouseValuationFind = async () => {
  setCallInProgress(true);
  const result = await apiHandler({
    url: endpoint.COLLATERAL_EVALUATION_FINDALL,
    authToken: authToken,
  });
  setCallInProgress(false);

  if (result?.data?.error_code) {
    toastUpdate("Error", result?.data?.user_description, true);
    return;
  }

  // normalize applicationSubType from checkbox
  const currentSubType = btPreFlag ? "PRE_PLEDGE" : null;

  // filter by branch
  const getBranchData = result?.data?.filter(
    (item) => item.branchCode?.toLowerCase() === branchName?.toLowerCase()
  );

  // find current record (if editing)
  const currentRecord = params.id
    ? getBranchData.find((item) => Number(item.id) === Number(params.id))
    : null;

  // remove current id if editing
  const checkBranchData = params.id
    ? getBranchData.filter((item) => Number(item.id) !== Number(params.id))
    : getBranchData;

  setPreviouseEvaluation(checkBranchData);

  // same combination check (role + branch + designation + applicationSubType)
  const sortedData = checkBranchData.filter(
    (item) =>
      item.role === selectedRoleCode &&
      item.branchCode === branchName &&
      item.designation === designation &&
      (item.applicationSubType ?? null) === currentSubType
  );

  setSameCombination(sortedData);

  if (sortedData.length > 0) {
    setBottomTextError("Same combination already exists");
    setDisabledButton1(true);
  } else {
    setBottomTextError("");
    setDisabledButton1(false);
  }

  // assign level
  if (!params.id) {
    // new record
    const subTypeFiltered = checkBranchData.filter(
      (item) => (item.applicationSubType ?? null) === currentSubType
    );
    setLevel(subTypeFiltered?.length + 1);
  } else {
    // editing record
    if ((currentRecord?.applicationSubType ?? null) === currentSubType) {
      // subtype not changed → keep its original level
      setLevel(currentRecord.level);
    } else {
      // subtype changed → assign next available level in new subtype
      const subTypeFiltered = checkBranchData.filter(
        (item) => (item.applicationSubType ?? null) === currentSubType
      );
      setLevel(subTypeFiltered?.length + 1);
    }
  }
};

  useEffect(() => {
    if (structureTypeData.length) {
      getBranchList();
    }
  }, [structureTypeData.length]);

  const getRoleList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_ROLE_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description,true);
    } else {
      setRoleList(result?.data);
    }
  };

  const getBranchList = async () => {
    let branchCodes = structureTypeData.filter((b) => b.branchType === true);
    if (branchCodes.length > 0) {
      branchCodes.forEach(async (branch) => {
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch?.code,
          authToken: authToken,
        });
        setCallInProgress(false);
        if (result?.data?.error_code) {
          toastUpdate("Error", result?.data?.user_description,true);
        } else {
          setBranchList(result?.data);
        }
      });
    }
  };

  // const GetHierarchyData = async () => {
  //   const result = await apiHandler({
  //     url: endpoint.MASTER_HIERARCHY_FINDALL,
  //     authToken: authToken,
  //   });
  //   if (result?.data?.error_code) {
  //   } else {
  //     setHierarchy(result?.data);
  //   }
  // };

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const editInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.COLLATERAL_EVALUATION_UPDATE + params?.id,
      method: "PUT",
      authToken: authToken,
      data: {
        role: selectedRoleCode,
        branchCode: branchName,
        minAmt: 0,
        maxAmt: Number(maxAmount),
        level: level,
        designation:designation,
        mandatory: mandatory,
        roleBasedApproval: roleBasedApproval,
        designationBasedApproval: designationBasedApproval,
        applicationSubType:applicantionSubTypeEnabledColateral ? btPreFlag ? "PRE_PLEDGE" : null : null,
        skip: params.id ? skipFlag : false,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const isValidated = () => {
    if (maxAmount < minAmount) {
      toastUpdate("Error", `Max Amount should be greather then ${minAmount}`,true);

      return false;
    } else {
      return true;
    }
  };
  const saveInformation = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.COLLATERAL_EVALUATION_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          role: selectedRoleCode,
          branchCode: branchName,
          minAmt: 0,
          maxAmt: Number(maxAmount),
          level: level,
          designation:designation,
          mandatory: mandatory,
          roleBasedApproval: roleBasedApproval,
          designationBasedApproval: designationBasedApproval,
          applicationSubType:applicantionSubTypeEnabledColateral ? btPreFlag ? "PRE_PLEDGE" : null : null,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description,true);
        return "ERROR";
      } else {
        return "SUCCESS";
      }
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "",false);
    let status = "";
    if (params.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }
    if (status === "SUCCESS") {
      const msg = params.id
        ? "Collateral valuation updated successfully!"
        : "Collateral valuation created successfully!";
        toastUpdate("Success", msg,true);
      setRedirectURL(`/coreservice/Collateral`);
    }
  };
  const handleCancel = () => {
    navigate("/coreservice/Collateral");
  };

  const handleBlur = (e) => {
    const enteredMaxAmount = Number(e);
  // Find the maximum amount for the previous level
  const maxAmountOfPreviousLevel = previouseEvaluation
  .filter(item => item.level < level)
  .reduce((max, item) => (item.maxAmt > max ? item.maxAmt : max), 0);
  
  // Find the maximum amount for the next level
  const maxAmountOfNextLevel = previouseEvaluation
  .filter(item => item.level > level)
  .reduce((min, item) => (item.maxAmt < min ? item.maxAmt : min), Infinity);
  
    // Validation based on create or edit mode
    if (!params.id) {
      // Create mode: Validate against the previous level only
      if (enteredMaxAmount <= maxAmountOfPreviousLevel) {
        toastUpdate("Error", `Max Amount should be greater than ${maxAmountOfPreviousLevel}`,true);
        setDisabledButton(true);
      }
    } else {
      // Edit mode: Validate against both previous and next levels
      if (enteredMaxAmount <= maxAmountOfPreviousLevel || enteredMaxAmount >= maxAmountOfNextLevel) {
        toastUpdate("Error", `Max Amount should be between ${maxAmountOfPreviousLevel} and ${maxAmountOfNextLevel}`,true);
        setDisabledButton(true);
      }
    }
  };
  
  const handleRoleCode = (e) => {
    setSelectedRoleCode(e);
    const currentSubType = btPreFlag ? "PRE_PLEDGE" : null;
    const sortedData = previouseEvaluation.filter(
      (item) =>
        item.role === e &&
        item.branchCode === branchName &&
        item.designation === designation &&
        (item.applicationSubType ?? null) === currentSubType
    );
    setSameCombination(sortedData);
    if (sortedData.length > 0) {
      setBottomTextError("Same combination already exit");
      setDisabledButton1(true);
    } else {
      setBottomTextError("");
      setDisabledButton1(false);
    }
  };

  const handleDesignationCode = (e) => {
    setDesignation(e);
    const currentSubType = btPreFlag ? "PRE_PLEDGE" : null;
    const sortedData = previouseEvaluation.filter(
      (item) =>
        item.designation === e &&
        item.branchCode === branchName &&
        item.role === selectedRoleCode &&
        (item.applicationSubType ?? null) === currentSubType
    );
    setSameCombination(sortedData);
    if (sortedData.length > 0) {
      setBottomTextError("Same combination already exit");
      setDisabledButton1(true);
    } else {
      setBottomTextError("");
      setDisabledButton1(false);
    }
  };
  const title = viewPage ? "View Collateral Valuation" : "Edit Collateral Valuation";
  const handleMaxAmount = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMaxAmount(e);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.id
              ? title
              : "Create Collateral Valuation"
          }
          button1={!viewPage && "Save"}
          button2=" Cancel"
          button1click={!viewPage && handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton || disabledButton1}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Branch Name*"
              error={branchNameState}
              id="branch_channel"
              value={branchName?.toUpperCase()}
              setState={setBranchName}
              data={branchList}
              setError={setBranchNameState}
              type="TYPE"
              disabled={params?.id || viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Role*"
              error={selectedRoleCodeState}
              id="user_role"
              value={selectedRoleCode}
              setState={handleRoleCode}
              data={roleList}
              setError={setSelectedRoleCodeState}
              type="roleNew"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Designation*"
              error={designationState}
              id="designationS"
              value={designation}
              setState={handleDesignationCode}
              data={designationData}
              setError={setDesignationState}
              type="designation"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Amount"
              required
              id="minamount"
              value={minAmount || ""}
              setState={setMinAmount}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Amount"
              required
              id="maxamount"
              value={maxAmount || ""}
              setState={handleMaxAmount}
              setBlur={handleBlur}
              disabled={viewPage || !branchName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Level*"
              id="level"
              value={level}
              setState={setLevel}
              disabled
            />
          </Grid>
          {applicantionSubTypeEnabledColateral &&
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
              {" "}
              <input
                style={{ marginTop: 2, width:'30px', height:'30px' }}
                id="selectAll"
                type="checkbox"
                checked={btPreFlag}
                className={classes.checkboxInput}
                onChange={(e) => setBtPreFlag(e.target.checked)}
              />{" "}
              BT Pre Pledge
            </label>
            </Grid>
          }
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
              {" "}
              <input
                style={{ marginTop: 2, width:'30px', height:'30px' }}
                id="selectAll"
                type="checkbox"
                checked={mandatory}
                className={classes.checkboxInput}
                onChange={(e) => setMandatory(e.target.checked)}
              />{" "}
              Mandatory
            </label>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
              {" "}
              <input
                style={{ marginTop: 2, width:'30px', height:'30px' }}
                id="selectAll"
                type="checkbox"
                checked={roleBasedApproval}
                className={classes.checkboxInput}
                onChange={(e) => setRoleBasedApproval(e.target.checked)}
              />{" "}
              Role Based
            </label>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
              {" "}
              <input
                style={{ marginTop: 2, width:'30px', height:'30px' }}
                id="selectAll"
                type="checkbox"
                checked={designationBasedApproval}
                className={classes.checkboxInput}
                onChange={(e) => setDesignationBasedApproval(e.target.checked)}
              />{" "}
              Designation Based
            </label>
            </Grid>
            {(params?.id && enabledSkipLevelCollateralValuation) &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
                {" "}
                <input
                  style={{ marginTop: 2, width:'30px', height:'30px' }}
                  id="selectAll"
                  type="checkbox"
                  checked={skipFlag}
                  className={classes.checkboxInput}
                  onChange={(e) => setSkipFlag(e.target.checked)}
                />{" "}
                Skip
              </label>
            </Grid>
            }
        </Grid>
        {bottomTextError && (
          <Grid item xs={12} sm={12} md={12} className={classes.bottomText}>
            {bottomTextError}
          </Grid>
        )}
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default CollateralEvaluationMasterCreate;
